






































































































































































































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable key-spacing */
/* eslint-disable class-methods-use-this */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import format from '@/libs/numberFormat';
import Button from '@/components/Button.vue';
import Modal from '@/components/Modal.vue';
import CloseIcon from 'mdi-vue/Close';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import FormInput from '@/components/FormInput.vue';
// import SimplePagination from '@/components/SimplePagination.vue';
// import PencilIcon from 'mdi-vue/SquareEditOutline';

@Component({
  components: {
    Button,
    Modal,
    CloseIcon,
    ScrollbarWrapper,
    Table,
    Row,
    TableBody,
    Header,
    Cell,
    FormInput,
    // SimplePagination,
    // PencilIcon,
  },
  methods: {
    format,
  },
  computed: mapState(['user']),
})

export default class StagingMatchModal extends Vue {
  isShowModal = false;

  showModal() {
    this.isShowModal = true;
  }

  closeModal() {
    this.isShowModal = false;
  }
}
